<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox addBox" v-if="addType">
        <div class="contv">
          <div class="write-txt" v-if="addType!='time'">
            <p class="write-title"><span>*</span>学员姓名：</p>
            <div class="write-text">
              <input type="text" v-model="addObj.name">
              <span>最多输入30个中/英、数字和特殊行号名称已重复</span>
            </div>
          </div>
          <div class="write-txt" v-if="addType!='time'">
            <p class="write-title"><span>*</span>性别：</p>
            <div class="write-text">
              <el-radio-group v-model="addObj.sex">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div class="write-txt" v-if="addType!='time'">
            <p class="write-title"><span>*</span>省市：</p>
            <div class="write-text">
              <el-cascader
                v-model="cityValue"
                :options="cityData"
                @change="handleChange"></el-cascader>
            </div>
          </div>

          <div class="write-txt" v-if="addType!='time'">
            <p class="write-title"><span>*</span>学校：</p>
            <div class="write-text">
              <input type="text" v-model="addObj.school">
              <span>最多输入30个中/英、数字和特殊行号名称已重复</span>
            </div>
          </div>

          <div class="write-txt" v-if="addType!='time'">
            <p class="write-title"><span>*</span>年级：</p>
            <div class="write-text">
              <input type="text" v-model="addObj.grade">
              <span>最多输入30个中/英、数字和特殊行号名称已重复</span>
            </div>
          </div>

          <div class="write-txt" v-if="addType!='time'">
            <p class="write-title"><span>*</span>手机号：</p>
            <div class="write-text">
              <div style="display: inline-block;vertical-align: top;">
                <input type="text" v-model="addObj.mobile" @input="numCheck(addObj.mobile,11,'mobile')">
                <span>最多输入30个中/英、数字和特殊行号名称已重复</span>
              </div>
            </div>
          </div>
          

          <div class="write-txt" v-if="addType=='time' || addType == 'add'">
            <p class="write-title"><span>*</span>有效期：</p>
            <div class="write-text">
              <!-- <div style="display: inline-block;vertical-align: top;">
                <input type="text" v-model="addObj.deadline" style="width: 100px;display: inline-block;vertical-align: top;">
                <el-radio-group v-model="deadline">
                  <el-radio label="d">天</el-radio>
                  <el-radio label="m">月</el-radio>
                  <el-radio label="y">年</el-radio>
                </el-radio-group>
                <span>请输入正整数</span>
              </div> -->
              <el-date-picker
                v-model="addObj.deadline"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </div>
          

          <div class="write-btnBox">
            <button class="btn btn-save" @click="saveSub">确定</button>
            <button class="btn btn-close" @click="closeSub">取消</button>
          </div>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="btnBox">
            <button class="btn btn-add" @click="updown">下载模板</button>
            <el-upload
              class="upload-demo btn btn-import"
              :action="url+'/intecl/Student/importStudent'"
              :headers="{'userToken':token}"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              accept=".xls, .xlsx"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">导入</el-button>
            </el-upload>
            <button class="btn btn-add" @click="addSub">添加学员</button>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>学生姓名：</p>
              <input type="text" placeholder="请输入要搜索的学生姓名" v-model="obj.name">
            </div>
            <div class="search-item">
              <p>手机号：</p>
              <input type="text" placeholder="请输入要搜索的手机号" v-model="obj.mobile">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">学员列表</div>
          <div class="titleList">
            <div class="title-item" :style="{ 'transform': 'translateX(' + offset1 + ')'}">
              <p v-for="(item,index) in titleList" v-bind:key="item.id" v-show="index < titleList.length-1">{{item.title}}</p>
            </div>
            <p class="last-title">{{titleList[titleList.length-1].title}}</p>
          </div>
          <div class="dataList" >
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <div class="list-item" :style="{ 'transform': 'translateX(' + offset1 + ')'}">
                <p :title="item.key">{{item.key}}</p>
                <p :title="item.name">{{item.name}}</p>
                <p :title="item.sex==1?'男':'女'">{{item.sex==1?'男':'女'}}</p>
                <p :title="item.province+'/'+item.city">{{item.province}} / {{item.city}}</p>
                <p :title="item.school">{{item.school}}</p>
                <p :title="item.grade">{{item.grade}}</p>
                <p :title="item.mobile">{{item.mobile}}</p>
                <p :title="item.create_time">{{item.create_time}}</p>
                <p :title="item.deadline">{{item.deadline}}</p>
              </div>
              <p class="last-list">
                <button title="编辑" class="btn btn-revise" @click="buildShow(item)">编辑</button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)">删除</button>
                <button title="修改有效期" class="btn btn-revise" @click="addTime(item)">修改有效期</button>
              </p>
            </div>
          </div>
          
          <!-- <div class="progress" @mousedown="handleDown" @mousemove="handleMouseMove" @mouseup="handleUp">
            <i class="line" :style="{ 'transform': 'translateX(' + offset + ')'}"></i>
          </div> -->

          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">{{removeTxt}}</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStudentList ,saveStudent,getStudentDetail ,delStudent ,addStudentDeadline} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import cityJson from './../assets/json/city.json'
export default {
  name: "index",
  data() {
    return {
      navId:'5',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'姓名'},
        {id:3,title:'性别'},
        {id:4,title:'地区'},
        {id:5,title:'学校'},
        {id:6,title:'年级'},
        {id:7,title:'手机号'},
        {id:8,title:'注册时间'},
        {id:9,title:'有效截止时间'},
        {id:10,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{},
      totalPage:0,
      removeID:'',
      url:'',
      sortList:[
        {id:1,title:'正序',value:'asc'},
        {id:2,title:'倒序',value:'desc'},
      ],
      fileUrl:'/static/Template.xlsx',
      cityData:[],
      cityValue:[],
      deadline:'d',
      moveType:false,
      offset:0,
      offset1:0,
      removeTxt:'是否确定删除？',
      pickerOptions: {
        disabledDate(time) {
          console.log(time)
          // 获取当前时间的毫秒数
          const now = Date.now();
          // 获取传入日期的毫秒数
          const date = time.getTime();
          // 如果传入日期的毫秒数小于当前时间的毫秒数，则返回true，表示禁用该日期
          return date < now;
        }
      },
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
    cityJson.forEach(function(item,index){
      item.children.forEach(function(ele,num){
        delete ele.children;
      })
    })
    this.cityData = cityJson;
  },
  methods: {
    handleDown(){
      this.moveType = true;
    },
    handleMouseMove(event) {
      const scrollContent = this.$refs.content;
      const scrollSpeed = 3; // 滑动速度
      if(this.moveType){
        this.offset = `${event.pageX / scrollSpeed - 65}px`;
        this.offset1 = `-${event.pageX / scrollSpeed - 65}px`;
        console.log(`${event.pageX / scrollSpeed - 65}px`,'this.offset')
      }
    },
    handleUp(){
      this.moveType = false;
    },
    
    handleChange() {
      var that = this;
      this.cityData.forEach(function(item,index){
        if(item.value == that.cityValue[0]){
          that.addObj.province = item.label;
        }
        item.children.forEach(function(ele,num){
          if(ele.value == that.cityValue[1]){
            that.addObj.city = ele.label;
          }
        })
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getStudentList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

     async buildShow(e){
      var that = this;
      this.cityValue = [];
      try {
        const response = await getStudentDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addType = 'edit';
          response.data.sex = JSON.stringify(response.data.sex);
          that.cityData.forEach(function(item,index){
            if(item.label == response.data.province){
              that.cityValue.push(item.value);
            }
            item.children.forEach(function(ele,num){
              if(ele.label == response.data.city){
                that.cityValue.push(ele.value);
              }
            })
          });
          that.addObj = response.data;
          that.addObj.id = e.id;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1; // 月份从0开始，所以要加1
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      var date1 = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
      var date2 = e.deadline ? e.deadline : '';
      console.log(date1,date2)
      if(date2 == ''){
        return false;
      }
      if (Date.parse(date1) < Date.parse(date2)) {
        console.log("dateStr1 在 dateStr2 之前");
        this.removeTxt = '有效还未到，是否确认删除'
      } else if (Date.parse(date1) > Date.parse(date2)) {
        console.log("dateStr1 在 dateStr2 之后");
      } else {
        console.log("dateStr1 和 dateStr2 相同");
      }
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delStudent({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addTime(e){
      // if ('speechSynthesis' in window) {
      //   const utterance = new SpeechSynthesisUtterance('');
      //   speechSynthesis.speak(utterance);
      // } else {
      //   alert('浏览器不支持语音合成');
      // }
      this.addType = 'time';
      this.addObj.id = e.id;
      this.$set(this.addObj,'deadline',e.deadline.split(' ')[0])
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      console.log(this.addObj.deadline,this.deadline)
      if(this.addObj.deadline == ''){
        that.$message('请填写有效期！');
        return false;
      }
      // this.addObj.deadline = this.addObj.deadline + this.deadline;
      if(this.addType == 'time'){
        try {
          const response = await addStudentDeadline(this.addObj,this.token);
          if(response.code == 200){
            that.$message('成功');
            that.closeSub();
            that.getList();        
          } else {
            that.$message(response.msg);
          }
        } catch (error) {
          that.$message(error);
        }
      } else {
        if(this.addObj.name == ''){
          that.$message('请输入姓名！');
          return false;
        }
        if(this.addObj.sex == ''){
          that.$message('请选择性别！');
          return false;
        }
        if(this.addObj.province == '' || this.addObj.city == ''){
          that.$message('请选择地区！');
          return false;
        }
        if(this.addObj.school == ''){
          that.$message('请选择学校！');
          return false;
        }
        if(this.addObj.grade == ''){
          that.$message('请选择年级！');
          return false;
        }
        if(this.addObj.mobile == ''){
          that.$message('请填写手机号！');
          return false;
        }
        try {
          const response = await saveStudent(this.addObj,this.token);
          if(response.code == 200){
            that.$message('成功');
            that.closeSub();
            that.getList();        
          } else {
            that.$message(response.msg);
          }
        } catch (error) {
          that.$message(error);
        }
      }
      
    },

    closeSub(){
      this.addType = '';
      this.addObj = {};
      this.cityValue = [];
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    beforeUpload(){
      this.loading = true;
    }, 
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.getList();
      } else {
        that.$message(response.msg);
      };
      that.loading = false;
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={};
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
        e = e.slice(0,11);
        that.addObj.mobile = e;
      }
    },
  }

  
};
</script>
<style scoped>
  .listItem .list-item p,
  .titleList .title-item p{
    width: calc( 100% / 9 );
    white-space: pre-line;
  }

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .searchBox{
    margin-top: 20px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  margin-left: 20px;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 20px;
  display: inline-block;
  margin-left: 20px;
}

.label-list{
  margin-top: 20px;
  margin-left: 160px;
}

.write-text .btn-add{
  display: inline-block;
  vertical-align: top;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  color: #fff;
  border-radius: 6px;
  background-color: #6098F2;
  margin-left: 20px;
  padding: 0 30px;
}


.MobelBox .write-ai .write-text{
  width: auto;
}


.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-remove{
  font-size: 20px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 20px;
}

.addBox{
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .6);
  width: 100%;
  height: 100%;
}

.addBox .contv{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  box-sizing: border-box;
  padding: 60px;
  width: 50%;
  border-radius: 8px;
}

.addBox .contv .write-btnBox{
  float: none;
  text-align: center;
  margin-top: 100px;
}

.addBox .contv .write-btnBox .btn{
  width: 181px;
  height: 58px;
  line-height: 58px;
  font-size: 30px;
}

.addBox .write-text span{
  display: none;
}

.addBox >>>.el-radio-group{
  display: inline-block;
  vertical-align: top;
  height: 50px;
  line-height: 50px;
  margin-left: 30px;
}

.addBox >>>.el-radio__inner,
.addBox >>>.el-radio__input{
  width: 24px;
  height: 24px;
}

.addBox >>>.el-radio__label{
  font-size: 18px;
}

.addBox >>>.el-radio__inner::after{
  width: 16px;
  height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/student/index.vue